import './MainPart.css';
import Col from '../OtherComponents/Col/Col';
import ColTwo from '../OtherComponents/Col/ColTwo';
import ColThree from '../OtherComponents/Col/ColThree';
import React, { useState } from 'react';
import NoteCard from '../OtherComponents/NoteCard/NoteCard';
import TaskCard from '../OtherComponents/Cards/TaskCard';
import GoalCard from '../OtherComponents/Cards/GoalCard';
import JournalCard from '../OtherComponents/Cards/JournalCard/JournalCard';
import JournalEntry from '../OtherComponents/Cards/JournalCard/JournalEntry/JournalEntry';
import KnowledgeCard from '../OtherComponents/Cards/KnowledgeCard';
import NoteRow from '../OtherComponents/NoteRow/NoteRow';
import NewNoteBar from '../OtherComponents/NewNoteBar/NewNoteBar';
function MainPart({darkBG, bgColor}){

    // View Toggle Settings

    const [activeToggle, setActiveToggle] = useState(null);

    const handleClick = (toggle) => {
        setActiveToggle(toggle);
    };

    const [activeToggleTwo, setActiveToggleTwo] = useState(null);

    const handleClickTwo = (toggle) => {
        setActiveToggleTwo(toggle);
    };

    const [activeToggleThree, setActiveToggleThree] = useState(null);

    const handleClickThree = (toggle) => {
        setActiveToggleThree(toggle);
    };
    

    return(
        <div className="main-part">

            
            <div className="fixed-width py-4">
                <div className="content">
                    <div className='row justify-content-center py-4'>
                        
                        <div className='row-div d-flex justify-content-between'>
                            <h2 className='main-content-heading gradient-text py-1'>Fixed cards</h2>
                            <div className='d-flex view-part'>
                                <p className='px-2 select-text'>Select view:</p>
                                <div className='row-div-icons pt-1'>
                                    <i onClick={() => handleClick('toggle-one')} class="fa-brands fa-windows px-2 toggle-one"></i>
                                    <i onClick={() => handleClick('toggle-two')} class="fa-solid fa-bars px-2 toggle-two"></i>
                                    <i onClick={() => handleClick('toggle-three')} class="fa-solid fa-list px-2 toggle-three"></i>
                                </div>
                            </div>
                        </div>

                        <Col activeToggle={activeToggle}>
                            <NoteRow darkBG={darkBG}>
                                <TaskCard darkBG={darkBG}/>
                            </NoteRow>
                        </Col>

                        <Col activeToggle={activeToggle}>
                            <NoteRow darkBG={darkBG}>
                                <GoalCard darkBG={darkBG}/>
                            </NoteRow>
                        </Col>

                        <Col activeToggle={activeToggle}>
                            <NoteRow darkBG={darkBG}>
                                <JournalCard darkBG={darkBG}>
                                    <JournalEntry darkBG={darkBG} bgColor={bgColor}/>
                                </JournalCard>
                            </NoteRow>
                        </Col>

                        <Col activeToggle={activeToggle}>
                            <NoteRow darkBG={darkBG}>
                                <KnowledgeCard darkBG={darkBG}/>
                            </NoteRow>
                        </Col>

                    </div>


                    <NewNoteBar bgColor={bgColor} darkBG={darkBG}/>

                    {/* Row 2 */}

                    <div className='row justify-content-center py-4'>
                        <div className='row-div d-flex justify-content-between'>
                            <h2 className='main-content-heading py-1'>Pinned notes</h2>
                            <div className='d-flex view-part'>
                                <p className='px-2 select-text'>Select view:</p>
                                <div className='row-div-icons pt-1'>
                                    <i onClick={() => handleClickTwo('toggle-one')} class="fa-brands fa-windows px-2 toggle-one"></i>
                                    <i onClick={() => handleClickTwo('toggle-two')} class="fa-solid fa-bars px-2 toggle-two"></i>
                                    <i onClick={() => handleClickTwo('toggle-three')} class="fa-solid fa-list px-2 toggle-three"></i>
                                </div>
                            </div>
                        </div>
                        
                        <ColTwo activeToggleTwo={activeToggleTwo}>
                            <NoteRow darkBG={darkBG}>
                                <NoteCard darkBG={darkBG}/>
                            </NoteRow>
                        </ColTwo>

                        <ColTwo activeToggleTwo={activeToggleTwo}>
                            <NoteRow darkBG={darkBG}>
                                <NoteCard darkBG={darkBG}/>
                            </NoteRow>
                        </ColTwo>

                        <ColTwo activeToggleTwo={activeToggleTwo}>
                            <NoteRow darkBG={darkBG}>
                                <NoteCard darkBG={darkBG}/>
                            </NoteRow>
                        </ColTwo>

                        <ColTwo activeToggleTwo={activeToggleTwo}>
                            <NoteRow darkBG={darkBG}>
                                <NoteCard darkBG={darkBG}/>
                            </NoteRow>
                        </ColTwo>

                    </div>


                    {/* Row 3 */}


                    <div className='row justify-content-center py-4'>
                        <div className='row-div d-flex justify-content-between'>
                            <h2 className='main-content-heading py-1'>Others</h2>
                            <div className='d-flex view-part'>
                                <p className='px-2 select-text'>Select view:</p>
                                <div className='row-div-icons pt-1'>
                                    <i onClick={() => handleClickThree('toggle-one')} class="fa-brands fa-windows px-2 toggle-one"></i>
                                    <i onClick={() => handleClickThree('toggle-two')} class="fa-solid fa-bars px-2 toggle-two"></i>
                                    <i onClick={() => handleClickThree('toggle-three')} class="fa-solid fa-list px-2 toggle-three"></i>
                                </div>
                            </div>
                        </div>
                        
                        <ColThree activeToggleThree={activeToggleThree}>
                            <NoteRow darkBG={darkBG}>
                                <NoteCard darkBG={darkBG}/>
                            </NoteRow>
                        </ColThree>

                        <ColThree activeToggleThree={activeToggleThree}>
                            <NoteRow darkBG={darkBG}>
                                <NoteCard darkBG={darkBG}/>
                            </NoteRow>
                        </ColThree>

                        <ColThree activeToggleThree={activeToggleThree}>
                            <NoteRow darkBG={darkBG}>
                                <NoteCard darkBG={darkBG}/>
                            </NoteRow>
                        </ColThree>

                        <ColThree activeToggleThree={activeToggleThree}>
                            <NoteRow darkBG={darkBG}>
                                <NoteCard darkBG={darkBG}/>
                            </NoteRow>
                        </ColThree>

                    </div>

                </div>
            </div>
        </div>
    )
}

export default MainPart;